import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';
import LinkIcon from '@mui/icons-material/Link';
import Imagez from '../../lib/reusable/Imagez';
import EventGallery from './components/EventsGallery';
import Moviez from '../../lib/reusable/Moviez';
import { RAFContext } from '../../core/contexts/RAFContext';

import { PlaceContext } from '../../core/contexts/PlaceContext';
import useEventsClick from './hooks/useEventClick';

import { useInViewLogger } from '../../core/hooks/useInViewLogger';

const StaticMovie = ({ onImageClick, event, type }) => {
  const {
    data: {
      place: { features },
    },
  } = useContext(PlaceContext);
  const { isMobile } = useContext(RAFContext);

  const viewRef = useInViewLogger({
    objectId: event.id,
    objectName: event.name,
    objectType: 'events',
    action: 'view',
    triggerInSeconds: 1.25,
    campaignId: event.campaignId,
    isActive: Boolean(features?.place?.logs),
  });

  return (
    <div ref={viewRef} className="WH100" onClick={onImageClick}>
      {type === 'url' && (
        <div className="p-abs p-top-right pt-4 mt-2 pr-8 l2" style={{ opacity: 0.75 }}>
          <LinkIcon className="txt-bread-crumb-trail s-24-i fds-2" />
        </div>
      )}
      <Moviez
        movie={event.src}
        rounded={false}
        dropShadow
        limitHeight={false}
        limitWidth={event?.spread?.configuration?.maxWidth}
      />
    </div>
  );
};

const StaticImage = ({ onImageClick, event, type }) => {
  const {
    data: {
      place: { features },
    },
  } = useContext(PlaceContext);

  const viewRef = useInViewLogger({
    objectId: event.id,
    objectName: event.name,
    objectType: 'events',
    action: 'view',
    triggerInSeconds: 1.25,
    campaignId: event.campaignId,
    isActive: Boolean(features?.place?.logs),
  });

  return (
    <div ref={viewRef} className="WH100" onClick={onImageClick}>
      {type === 'url' && (
        <div className="p-abs p-top-right pt-4 mt-2 pr-8 l2" style={{ opacity: 0.75 }}>
          <LinkIcon className="txt-bread-crumb-trail s-24-i fds-2" />
        </div>
      )}
      <Imagez image={event.src} dropShadow />
    </div>
  );
};

const EventsPlacer = ({ menuPosition, enforce, productData }) => {
  const {
    data: {
      cache: { events },
    },
  } = useContext(PlaceContext);

  const { clickHandler } = useEventsClick();

  if (!events || events.length === 0 || !menuPosition) {
    return null;
  }

  const isProductEvent = productData && menuPosition === 'products' && enforce === 'product';
  const incomingProductEvents =
    isProductEvent && productData
      ? events?.products?.[productData.categoryId]?.[productData.productId]?.events
      : [];

  const productEvents = isProductEvent
    ? incomingProductEvents.filter((event) => Boolean(event))
    : [];

  const eventsToFilter = isProductEvent ? productEvents : (events?.[menuPosition] ?? []);
  const eventsList =
    eventsToFilter.filter((event) => {
      if (enforce) {
        return enforce === event?.spread?.position || isProductEvent;
      }

      return true;
    }) || [];

  const eventsGallery = eventsList.filter((event) => event?.spread?.gallery === true);
  const eventsStatic = eventsList.filter((event) => event?.spread?.gallery === false);

  return (
    <>
      {eventsGallery.length > 0 && (
        <EventGallery events={eventsGallery} clickHandler={clickHandler} />
      )}
      <div className="p-rel f-c f-aic mt-8 mb-16">
        <Grid container spacing={2}>
          {eventsStatic.map((event) => {
            let type = null;
            if (Boolean(event?.link?.url)) type = 'url';
            if (Boolean(event?.link?.service)) type = 'service';
            if (Boolean(event?.link?.category)) type = 'category';
            if (Boolean(event?.link?.product)) type = 'product';

            const onImageClick = clickHandler(type, event);

            if (event.type === 'mp4') {
              return (
                <Grid size={12} key={event.id}>
                  <StaticMovie onImageClick={onImageClick} event={event} type={type} />
                </Grid>
              );
            }

            return (
              <Grid size={12} key={event.id}>
                <StaticImage onImageClick={onImageClick} event={event} type={type} />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </>
  );
};

export default EventsPlacer;
